import { Link } from 'react-router-dom';
import { loreCategories } from '@/mocks/lore';

const categoryCards = [
  {
    key: 'worldview',
    label: '世界观',
    desc: '三层世界结构、交易铁律与库房的隐藏秩序。',
    icon: 'ri-earth-line',
  },
  {
    key: 'character',
    label: '角色与来历',
    desc: '店主的身世之谜，以及每件商品背后的故事。',
    icon: 'ri-user-heart-line',
  },
  {
    key: 'story',
    label: '故事背景',
    desc: '单元剧之下的暗线，与新手阅读路线指南。',
    icon: 'ri-route-line',
  },
  {
    key: 'deep',
    label: '深度解读',
    desc: '从“洞洞”二字的哲学，到隐藏的叙事细节。',
    icon: 'ri-quill-pen-line',
  },
];

export default function CategoryShowcase() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-800">
          <i className="ri-archive-drawer-line text-sm" aria-hidden="true"></i>
          内容分区
        </span>
        <h2 className="mt-4 text-2xl leading-relaxed text-foreground-950 md:text-3xl">按你的需要，走进不同的角落</h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-foreground-600">
          无论你是刚入门想搞懂“洞洞杂货铺漫画是什么”，还是老读者想深挖设定细节，都能在这里找到对应的篇章。
        </p>
      </div>

      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {categoryCards.map((c) => (
          <Link
            key={c.key}
            to="/lore"
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-200 hover:bg-background-100"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
              <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
            </span>
            <h3 className="mt-4 text-lg font-semibold text-foreground-950">{c.label}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-sm text-primary-700">
              浏览内容
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>

      <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
        {loreCategories.map((c) => (
          <span key={c.key} className="rounded-full bg-background-100 px-4 py-1.5 text-sm text-foreground-600">
            {c.label}
          </span>
        ))}
      </div>
    </section>
  );
}